export default "__VITE_ASSET__BVr50FC7__"